import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import cancellationPolicy from '../../../assets/images/cancellation-policy.jpg'
import InnerBanner from '../../molecules/InnerBanner/InnerBanner'

const Cancellationpolicy = () => {
    return (
        <>

            <InnerBanner
                title="Cancellation Policy"
                // subtitle="The Europcar Story"
                imageSrc={cancellationPolicy}
                imageAlt="CancellationPolicy"
            />
            <section className="policy-section section-padding">
                <Container>
                    <Row className='policy-section--row'>
                        <Col className="col-12 col">
                            <div className="mb-4">
                                <h3 className="h3 text-uppercase">Introduction</h3>
                                <p style={{ textAlign: 'justify' }}>
                                    We understand that plans may change and you may need to cancel your car rental booking. To ensure transparency and fairness, we’ve outlined our cancellation policy below. These terms apply to all bookings made through our website or mobile app.
                                </p>

                            </div>
                            <div className="mb-4">
                                <h3 className="h3 text-uppercase">General Guidelines</h3>
                                <p style={{ textAlign: 'justify' }}>
                                    Cancellations must be made through our official platform or by contacting our customer support team. Refund eligibility depends on the time at which the cancellation request is received relative to the scheduled rental start time.

                                </p>
                            </div>
                            <div className="mb-4">
                                <h3 className="h3 text-uppercase mb-3">Cancellation Charges</h3>
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col">Sl. No.</th>
                                            <th scope="col">Cancellation Timeframe</th>
                                            <th scope="col">Cancellation Charges</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th scope="row">1</th>
                                            <td>More than 24 hours before rental start time</td>
                                            <td>No cancellation charges. A full refund will be processed.</td>

                                        </tr>
                                        <tr>
                                            <th scope="row">2</th>
                                            <td>Between 06 to 24 hours before rental start time</td>
                                            <td>50% cancellation charges will be applied. Half the booking amount will be refunded.</td>

                                        </tr>
                                        <tr>
                                            <th scope="row">3</th>
                                            <td>Less than 06 hours before rental start time</td>
                                            <td>100% cancellation charges will apply. No refund will be provided.</td>

                                        </tr>
                                        <tr>
                                            <th scope="row">4</th>
                                            <td>No-show (User does not arrive at pickup time)</td>
                                            <td>100% cancellation charges will apply. No refund will be provided.</td>

                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                            <div className='mb-4'>
                                <h3 className="h3 text-uppercase">Additional Information</h3>
                                <ul style={{ listStyle: 'disc', textAlign: 'justify' }}>
                                    <li>If a booking is cancelled in accordance with our policy, the refund amount (if any) will be processed within 10 business days, depending on your payment method.</li>
                                    <li>No refunds will be made for partially used rentals or unused hours.</li>
                                    <li>If the booking includes a promotional discount or offer, the refund will be adjusted accordingly, and promotional codes may not be reissued.</li>
                                    <li>In case of any dispute or exceptional situations (natural calamities, road closure, etc.), our decision shall be final and binding.</li>
                                </ul>

                            </div>
                            <div className='mb-4'>
                                <h3 className="h3 text-uppercase">How to Cancel Your Booking</h3>
                                <p>You can cancel your booking easily through:</p>
                                <ul style={{ listStyle: 'disc', textAlign: 'justify' }}>
                                    <li><strong>Website:</strong> Log in to your account and go to "Manage Booking".</li>
                                    <li><strong>Customer Support:</strong> Call us at <a href='tel:+918421555659'>+91 8421555659</a> or email <a href='mailto:car.reservations@europcar.in'>car.reservations@europcar.in</a> with your booking reference number.</li>

                                </ul>
                                <p>If you have any questions or require assistance with your cancellation, please feel free to contact our support team. We're here to help.
                                </p>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>


        </>
    )
}

export default Cancellationpolicy;
